import React, { createContext, useEffect, useState } from "react";

export const InstallPromptContext = createContext();

export const InstallPromptProvider = ({ children }) => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstallable, setIsInstallable] = useState(false);

    useEffect(() => {
        const handler = (e) => {
            // console.log("e", e); 

            e.preventDefault();
            setDeferredPrompt(e);
            setIsInstallable(true);
        };

        window.addEventListener("beforeinstallprompt", handler);

        return () => {
            window.removeEventListener("beforeinstallprompt", handler);
        };
    }, []);

    return (
        <InstallPromptContext.Provider value={{ deferredPrompt, isInstallable, setIsInstallable }}>
            {children}
        </InstallPromptContext.Provider>
    );
};
